import { Component, OnInit } from '@angular/core';
import { PlayerService } from '../player.service';
import { WordpressService } from '../wordpress.service';
import { Subject,Observable }    from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  delete:boolean = false;
  isPlay:boolean = false;
  isStop:boolean = false;
  icy_metadata:string = "";
  title:string = "";
  duration = "";
  currentTime = "";
  init:boolean = false;

  constructor(
    public playerService:PlayerService,
    public http:HttpClient,
  ) {
    /* subscribe to app init */
    playerService.init_app$
    .subscribe(
      (res:boolean) => { this.init = res; }
    )
    /* subscribe to metada info */
    playerService.icy_metadata$
    .subscribe(
      (res:string) => { this.icy_metadata=res;}
    )
    /* subscribe to post info */
    playerService.podcast$
    .subscribe(
      (post) => { this.title = post[0].title.rendered }
    )
    /* subscribe isPlaying */
    playerService.audio_is_playing$
    .subscribe(
      (res:boolean) => {
        this.isPlay=res;
      }
    )
    /* subscribe timer */
    playerService.audio_current_time$
    .subscribe(
      (res:any) => {
        this.duration = res.duration;
        this.currentTime = res.currentTime;
      }
    )
  }

  ngOnInit() {

  }

  mute() {
    this.playerService.mute()
    this.delete = !this.delete;
  }

  play() {
    this.playerService.pause();
  }

  stop() {
    this.playerService.restart();
    this.title="";
    this.icy_metadata="";
    this.currentTime="";
    this.duration="";
  }

}
